<div class="row row-medium" *ngIf="showChart('Electricity')">
    <div data-chart="electricity" class="col-12 col-md-6">
        <app-electricity-chart class="d-flex align-self-stretch flex-grow-1"></app-electricity-chart>
    </div>
    <div data-chart="dayOfWeekElectricity" class="col-12 col-md-6">
        <app-day-of-week-chart [selectedMeasurement]="defaultMeasurement('Electricity')"
                               class="d-flex align-self-stretch flex-grow-1"></app-day-of-week-chart>

    </div>
</div>
<div class="row row-medium">
    <div class="col-12 col-md-6 d-flex align-items-stretch">
        <app-meter-performance-chart class="d-flex align-self-stretch flex-grow-1"></app-meter-performance-chart>
    </div>
    <div class="col-12 col-md-6 d-flex align-items-stretch">
        <div class="card flex-grow-1">
            <div class="card-header">
                <h4 class="card-header-title">
                    <img src="assets/images/icons/environmentalism.png" width="20px" class="me-2">
                    Energy compass
                </h4>
            </div>
            <div class="card-body d-flex flex-grow-1">
                <app-meter-energy-compass
                        [meters]="meterEntities"
                        class="d-flex flex-grow-1">
                </app-meter-energy-compass>
            </div>
        </div>
    </div>
</div>
<div class="row row-medium" *ngIf="!onlyConnectionSelected">
    <div class="col-12 col-md-4 d-flex align-items-stretch">
        <ng-container *ngIf="meterLocation(); else noLocation">
            <div class="card flex-grow-1">
                <div class="card-body">
                    <app-location-energy-label-info [location]="meterLocation()"></app-location-energy-label-info>
                </div>
            </div>
        </ng-container>
        <ng-template #noLocation>
            <div class="d-flex card flex-column" style="flex: 1">
                <div class="card-header">
                    <h4 class="card-header-title">
                        Energy label
                    </h4>
                </div>

                <div class="card-body d-flex justify-content-center align-items-center flex-grow-1 text-center">
                    <h2 class="m-0">
                        No location data available, or the selected meters are not associated with the same location.
                    </h2>
                </div>
            </div>
        </ng-template>
    </div>
    <div class="col-12 col-md-4 d-flex align-items-stretch">
        <app-costs-chart class="card d-flex align-self-stretch flex-grow-1"></app-costs-chart>
    </div>
    <div data-chart="co2" class="col-12 col-md-4 d-flex align-items-stretch">
        <app-co2-chart class="card d-flex align-self-stretch flex-grow-1"></app-co2-chart>
    </div>
</div>
<div class="row row-medium" *ngIf="showChart('Gas')">
    <div data-chart="gas" class="col-12 col-md-6">
        <app-gas-chart class="d-flex align-self-stretch flex-grow-1"></app-gas-chart>
    </div>
    <div data-chart="dayOfWeekGas" class="col-12 col-md-6">
        <app-day-of-week-chart
                [selectedMeasurement]="defaultMeasurement('Gas')"
                class="d-flex align-self-stretch flex-grow-1">
        </app-day-of-week-chart>
    </div>
</div>
<div class="row row-medium" *ngIf="showChart('Water')">
    <div data-chart="water" class="col-12 col-md-6">
        <app-water-chart class="d-flex align-self-stretch flex-grow-1"></app-water-chart>
    </div>
    <div data-chart="dayOfWeekWater" class="col-12 col-md-6">
        <app-day-of-week-chart
                [selectedMeasurement]="defaultMeasurement('Water')"
                class="d-flex align-self-stretch flex-grow-1">
        </app-day-of-week-chart>
    </div>
</div>
<div class="row row-medium" *ngIf="showChart('ChargePoint')">
    <div data-chart="chargePoint" class="col-12 col-md-6">
        <app-chargepoint-chart class="d-flex align-self-stretch flex-grow-1"></app-chargepoint-chart>
    </div>
    <div data-chart="dayOfWeekChargePoint" class="col-12 col-md-6">
        <app-day-of-week-chart
                [selectedMeasurement]="defaultMeasurement('ChargePoint')"
                class="d-flex align-self-stretch flex-grow-1">
        </app-day-of-week-chart>
    </div>
</div>
